import { ReactElement } from "react";
import "./custom-modal.scss";

import { Modal } from "antd";

type Iprops = {
  children?: any,
  isVisible?: boolean,
  onClose?: () => void,
  onOk?: () => void,
  style?: {[key: string]: string},
  width?: number,
  className?: string,
  centered?: boolean,
  showClose?: boolean
}

const CustomModal: React.FC<Iprops> = ({
  children,
  isVisible,
  onClose,
  onOk,
  style,
  className,
  width,
  centered,
  showClose = true
}): ReactElement  => {
  return (
    <Modal
      wrapClassName={`custom-modal ${className} ${!showClose ? 'remove-close' : ''}`}
      open={isVisible}
      onCancel={onClose}
      centered={centered}
      footer={null}
      style={style}
      width={width}
      onOk={onOk}
      destroyOnClose={true}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
